import { FC, useState } from 'react';

import Dropdown from '..';

import styles from './styles.module.scss';
import Button from '../../Button';
import { useMediaQuery } from '@mui/system';

type Props = {
    trigger: React.ReactElement;
    options: {
        label: string;
        onClick: () => void;
    }[];
};

const DropdownMenu: FC<Props> = ({ trigger, options }) => {
    const [open, setOpen] = useState(false);
    const isMobile = useMediaQuery("(max-width: 1050px)");

    const handleOptionsClick = (onClick: () => void) => {
        onClick();
        setOpen((prev) => !prev);
    }

    return (
        <Dropdown
            open={open}
            setOpen={setOpen}
            direction="bottom-right"
            trigger={trigger}
        >
            <div className={styles.content_container}>
                {options.map((option) => (
                    <Button
                        key={option.label}
                        labelOptions={{ align: "left", noWrap: true }}
                        size={isMobile ? "large" : "small"}
                        variant="transparent"
                        label={option.label}
                        onClick={() => handleOptionsClick(option.onClick)}
                        className={styles.option_button}
                    />
                ))}
            </div>
        </Dropdown>
    );
};

export default DropdownMenu;